import { useMemo } from "react";
import JsonLd from "./JsonLd";

function stripHtml(value = "") {
    return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function buildFAQSchema(items, pageUrl) {
    const questions = (items || [])
        .map((item) => ({
            question: stripHtml(item.question || item.name),
            answer: stripHtml(item.answer || item.text),
        }))
        .filter((item) => item.question && item.answer);

    if (questions.length === 0) return null;

    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        ...(pageUrl ? { "@id": `${pageUrl}#faq`, url: pageUrl } : {}),
        mainEntity: questions.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
            },
        })),
    };
}

export default function FAQSchema({ id = "page-faq", items = [], pageUrl }) {
    const schema = useMemo(
        () => buildFAQSchema(items, pageUrl),
        [items, pageUrl]
    );

    if (!schema) return null;

    return <JsonLd id={id} data={schema} />;
}
